/**
 * 点击元素外部区域时触发
 * Usage:
 * <div v-click-outside="handleClickOutside">
 * <div v-click-outside.reverse="handleClickInside">
 */
import $ from 'jquery'
import { sub, unSub, CLICK_OUTSIDE } from '../../core/utils/KGevent'

const context = 'directive-click-outside'

export default {
  bind(el, binding, vnode) {
    const $el = $(el)

    $el.data(context, {
      innerHandler: binding.value,
      handler(target) {
        if (!vnode.context) {
          return
        }

        const both = binding.modifiers.both
        const reverse = binding.modifiers.reverse
        const clickOutside = !el.contains(target)

        if (both) {
          binding.value.bind(vnode.context)(target, clickOutside)
          return
        }

        if (reverse) {
          if (!clickOutside) {
            binding.value.bind(vnode.context)(target)
          }
        } else if (clickOutside) {
          binding.value.bind(vnode.context)(target)
        }
      },
    })

    sub(CLICK_OUTSIDE, $el.data(context).handler)
  },
  update(el, binding) {
    $(el).data(context).innerHandler = binding.value
  },
  unbind(el) {
    unSub(CLICK_OUTSIDE, $(el).data(context))
  },
  install(Vue) {
    Vue.directive('click-outside', {
      bind: this.bind,
      unbind: this.unbind,
    })
  },
}
